import { render, staticRenderFns } from "./subsRetention.vue?vue&type=template&id=7fbc74fb&scoped=true"
import script from "./subsRetention.vue?vue&type=script&lang=js"
export * from "./subsRetention.vue?vue&type=script&lang=js"
import style0 from "./subsRetention.vue?vue&type=style&index=0&id=7fbc74fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc74fb",
  null
  
)

export default component.exports